// SIWS CUSTOM: Reusable qty stepper behavior.
// Delegated from document — handles every [data-qty-stepper] on the page.
// Fires CustomEvent('qty-stepper:change', { detail: { variantId, value } })
// on the input element (bubbles) so consumers can react without rebinding.

'use strict';

(function () {
  // SIWS: ghost zero — empty string is the "0" UI state; never numeric 0 in the input.
  const EMPTY = '';

  function getCfg(stepper) {
    return {
      min:    parseInt(stepper.dataset.min, 10),
      step:   parseInt(stepper.dataset.step, 10),
      max:    stepper.dataset.max ? parseInt(stepper.dataset.max, 10) : null,
      locked: stepper.dataset.locked === 'true',
    };
  }

  function getInput(stepper) {
    return stepper.querySelector('.siws-qty-stepper__input');
  }

  function dispatchChange(stepper, input) {
    const detail = {
      variantId: stepper.dataset.variantId,
      value:     input.value === EMPTY ? null : parseInt(input.value, 10),
    };
    input.dispatchEvent(new CustomEvent('qty-stepper:change', {
      detail,
      bubbles: true,
    }));
  }

  function setValue(stepper, input, raw) {
    const cfg = getCfg(stepper);
    if (raw === EMPTY || raw === null) {
      input.value = EMPTY;
    } else {
      let v = parseInt(raw, 10);
      if (cfg.max != null && v > cfg.max) v = cfg.max;
      input.value = String(v);
    }
    dispatchChange(stepper, input);
  }

  function plus(stepper) {
    if (getCfg(stepper).locked) return;
    const input = getInput(stepper);
    const cfg   = getCfg(stepper);
    if (input.value === EMPTY) {
      setValue(stepper, input, cfg.min);
      return;
    }
    const next = parseInt(input.value, 10) + cfg.step;
    setValue(stepper, input, next);
  }

  function minus(stepper) {
    if (getCfg(stepper).locked) return;
    const input = getInput(stepper);
    const cfg   = getCfg(stepper);
    if (input.value === EMPTY) return;
    const cur = parseInt(input.value, 10);
    if (cur <= cfg.min) {
      setValue(stepper, input, EMPTY);
      return;
    }
    setValue(stepper, input, cur - cfg.step);
  }

  // Snap blurred input to nearest valid (multiple of step, ≥ min, ≤ max).
  // Empty stays empty.
  function snap(stepper) {
    const input = getInput(stepper);
    const cfg   = getCfg(stepper);
    const raw   = input.value.trim();
    if (raw === EMPTY) {
      // Already empty → still emit a change so consumers re-evaluate.
      dispatchChange(stepper, input);
      return;
    }
    const parsed = parseInt(raw, 10);
    if (Number.isNaN(parsed)) {
      setValue(stepper, input, EMPTY);
      return;
    }
    let v = Math.max(parsed, cfg.min);
    // Round to nearest step at or above min: ((v - min) / step) rounded → * step + min
    const multiples = Math.round((v - cfg.min) / cfg.step);
    v = cfg.min + multiples * cfg.step;
    if (v < cfg.min) v = cfg.min;
    if (cfg.max != null && v > cfg.max) v = cfg.max;
    setValue(stepper, input, v);
  }

  document.addEventListener('click', function (e) {
    const plusBtn  = e.target.closest('[data-qty-stepper-plus]');
    const minusBtn = e.target.closest('[data-qty-stepper-minus]');
    if (!plusBtn && !minusBtn) return;
    const stepper = (plusBtn || minusBtn).closest('[data-qty-stepper]');
    if (!stepper) return;
    if (plusBtn)  plus(stepper);
    if (minusBtn) minus(stepper);
  });

  document.addEventListener('blur', function (e) {
    if (!e.target.matches('.siws-qty-stepper__input')) return;
    const stepper = e.target.closest('[data-qty-stepper]');
    if (stepper) snap(stepper);
  }, true); // capture: blur doesn't bubble.
})();
